import * as types from '../types'
import * as Api from "../../page/teacher/prepareCourse/indexApi";
import {
    getSubjectsClassesCourses
} from "@/api/commonApi.js";

export default {
    state: {
        classInfo: {},
        firstCourseInfo: {},
        courseInfo: {},
        rootSubjectInfo: {},
        secondSubjectInfo: {},
        thirdSubjectInfo: {},
        lastSubjectInfo: {}
    },
    getters: {
        classInfo: state => {
            return state.classInfo
        }
    },
    mutations: {
        SET_CLASS_INFO: (state, data) => {
            state.classInfo = data;
        },
        SET_FIRST_COURSE_INFO: (state, data) => {
            state.firstCourseInfo = data;
        },
        SET_COURSE_INFO: (state, data) => {
            state.courseInfo = data;
        },
        SET_ROOTSUBJECT_INFO: (state, data) => {
            state.rootSubjectInfo = data;
        },
        SET_SECONDSUBJECT_INFO: (state, data) => {
            state.secondSubjectInfo = data;
        },
        SET_THIRDSUBJECT_INFO: (state, data) => {
            state.thirdSubjectInfo = data;
        },
        SET_LASTSUBJECT_INFO: (state, data) => {
            state.lastSubjectInfo = data;
        },
    },
    actions: {
        // 设置页面信息
        SET_PREPATRE_COURSE_INFO({
            commit
        }, data) {
            commit('SET_CLASS_INFO', data.class);
            commit('SET_COURSE_INFO', data.course);
            commit('SET_ROOTSUBJECT_INFO', data.root_subject);
            commit('SET_SECONDSUBJECT_INFO', data.second_subject);
            commit('SET_THIRDSUBJECT_INFO', data.third_subject);
            commit('SET_LASTSUBJECT_INFO', data.course);
            commit('SET_FIRST_COURSE_INFO', data.first_course);
        },
        // 获取科目列表
        GET_ROOT_SUBJECT_LIST({
            commit
        }) {
            return new Promise((resolve, reject) => {
                Api.getTeacherSubjects()
                    .then(res => {
                        if (res.errCode == 0) {
                            resolve(res);
                        }
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },
        // 获取年级列表
        GET_SECOND_SUBJECT_LIST({
            commit
        }, data) {
            return new Promise((resolve, reject) => {
                Api.getSecondSubjects(data)
                    .then(res => {
                        if (res.errCode == 0) {
                            resolve(res);
                        }
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },
        // 获取章列表
        GET_ThIRD_SUBJECT_LIST({
            commit
        }, data) {
            return new Promise((resolve, reject) => {
                Api.getThirdSubjects(data)
                    .then(res => {
                        if (res.errCode == 0) {
                            resolve(res);
                        }
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },
        // 获取节列表
        GET_LAST_SUBJECT_LIST({
            commit
        }, data) {
            return new Promise((resolve, reject) => {
                Api.getAkdmOrClassesCourse(data)
                    .then(res => {
                        if (res.errCode == 0) {
                            resolve(res);
                        }
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },
        // 获取多章获取多节列表
        GET_MULTI_LAST_SUBJECT_LIST({
            commit
        }, data) {
            return new Promise((resolve, reject) => {
                getSubjectsClassesCourses(data)
                    .then(res => {
                        if (res.errCode == 0) {
                            resolve(res);
                        }
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },
    }
}